import { QuoteErrorCodes, createErrorLookup } from '~/common/helpers';

export const PricingPolicyErrorCodesLookup = createErrorLookup({
  [QuoteErrorCodes.ERR_ACTIVE_PRICING_POLICY_EXISTS]:
    'app.quote.pricing_policy.errors.err_active_pricing_policy_exists' as const,
  [QuoteErrorCodes.ERR_QUOTE_DUPLICATE_ERROR]:
    'app.purchase.quote.history.error.duplicate' as const,
});
